<template>
    <div :style="{'font-family':item.font,'font-size':item.fontSize}">
        {{item.text}}：
    </div>
</template>

<script>
    export default {
        name: "DocToOrg",
        props: {
            item: {},
        }
    }
</script>